import * as React from 'react';

export const blocksDataKids = [
  {
    bage: 'Блок 1',
    amount: '9 уроков',
    duration: 'Общая продолжительность 3 часа',
    title: 'Подготовительный блок',
    description:
      <>
        <p>Состоит из игровых заданий на развитие интеллектуальных навыков, коротких завлекающих текстов, упражнений на улучшение показателей чтения. Содержит проверочные блоки и дополнительные материалы для закрепления навыков.</p>
        <p>Результаты, полученные на игровых занятиях мягко вовлекают ребёнка в увлекательный процесс развития, показывая ему, что он может быть успешным в учёбе и формируют необходимый фундамент для последующего обучения. Результат - ребёнок испытывает wow-эффект и с энтузиазмом переходит к следующим разделам курса.</p>
      </>
  },
  {
    bage: 'Блок 2',
    amount: '25 уроков',
    duration: 'Общая продолжительность 12 часов',
    title: 'Развитие навыков чтения и мнемотехники',
    description:
      <>
        <p>Направлен на улучшение показателей чтения и развитие базовых навыков запоминания информации.</p>
        <p><strong>Содержимое блока:</strong></p>
        <p><strong>· Упражнения по эффективному чтению</strong>  — двигаясь от простого к сложному, ребёнок от урока к уроку овладевает разными техниками чтения.</p>
        <p><strong>· Видеоуроки с теорией и практика на интерактивных тренажёрах</strong> позволит сформировать навык запоминания простых видов информации:<br />
          – словарные и иностранные слова,<br />
          – даты,<br />
          – простые термины,<br />
          – авторы произведений<br />
          – простые формулы</p>
        <p><strong>· Игровые проверочные упражнения</strong></p>
      </>
  },
  {
    bage: 'Блок 3',
    amount: '30 уроков',
    duration: 'Общая продолжительность 15 часов',
    title: 'Развитие навыков эффективной работы с текстами',
    description:
      <>
        <p><strong>Содержимое блока:</strong></p>
        <p><strong>· Упражнения по эффективному чтению</strong>  — постепенно увеличиваются объёмы текстов, осваиваются новые способы чтения.</p>
        <p><strong>· Видеоуроки с теорией и совместной практикой с преподавателем</strong> позволят ребёнку:<br />
          – запоминать сложные таблицы и системы данных<br />
          – запоминать сложные формулы<br />
          – работать с майнд-картами (интеллект-картами)<br />
          – быстро осваивать сложные термины и определения</p>
        <p><strong>· Игровые проверочные упражнения</strong></p>
      </>
  },
  {
    bage: 'Блок 4',
    amount: '80 уроков',
    duration: 'Общая продолжительность 40 часов',
    title: 'Закрепление полученных навыков на материалах продвинутого уровня',
    description:
      <>
        <p><strong>Содержимое блока:</strong></p>
        <p><strong>· Упражнения продвинутого уровня</strong>  на улучшение показателей чтения.</p>
        <p><strong>· Главный результат:</strong> способность самостоятельно проработать целый параграф учебника, выделив из него главное, структурировать и сохранить эту информацию.</p>
        <p><strong>· Игровые проверочные упражнения</strong></p>
      </>
  },
  {
    bage: 'Блок 5',
    amount: '50 уроков',
    duration: 'Общая продолжительность 25 часов',
    title: 'Применение навыков на примерах школьной программы',
    description:
      <>
        <p><strong>Содержимое блока:</strong></p>
        <p><strong>· Улучшение показателей чтения</strong>  (упражнения продвинутого уровня) с опорой на школьную программу.</p>
        <p><strong>· Видеоуроки с теорией и совместной практикой с преподавателем.</strong> Применение мнемотехники на темах из школьных предметов. Работа с информацией на более высоком уровне: майнд-карты, выделение главных мыслей, работа с классификациями. Проработка школьных тем.</p>
        <p><strong>· Игровые проверочные упражнения</strong></p>
        <p>В данном блоке инструменты эффективного обучения отрабатываются на материалах учебников, что облегчает применение навыков в жизнь ученика. </p>
      </>
  },
];
